import { render, staticRenderFns } from "./WebstoreApiTokenDeleteButton.vue?vue&type=template&id=0d225598&scoped=true&"
import script from "./WebstoreApiTokenDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./WebstoreApiTokenDeleteButton.vue?vue&type=script&lang=ts&"
import style0 from "./WebstoreApiTokenDeleteButton.vue?vue&type=style&index=0&id=0d225598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d225598",
  null
  
)

export default component.exports